import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AlertModalPaywaySucces from 'components/AlertModalPaywaySucces/AlertModalPaywaySucces';
import { useTranslation } from 'hooks/useTranslation';
import { PAYPAL_ACCOUNTS_GRID_SCREEN_KEYS } from '../translationKeys';
import { PayPalAccountsHeader } from '../components/PayPalAccountsHeader';
import { PayPalAccountsActions } from '../components/PayPalAccountsActions';
import { PayPalAccountsGrid } from '../components/PayPalAccountsGrid';
import { GATEWAY_CODES } from '../../../constants';

// Copia de containers/Payment/PayPal/screens/PayPalAccountsGridScreen.js.
// Diferencias:
// - las cuentas llegan por prop (en Payment salían de Redux currentWFS);
// - el modal de éxito se dispara con estado local, no con
//   sessionStorage['paypal_vault_success'];
// - su auto-cierre cierra el flujo QR en vez de ir al checkout.
const GATEWAY = GATEWAY_CODES.PAYPAL;

export const PayPalAccountsGridScreen = ({
  accounts = [],
  showSuccessModal = false,
  onSuccessClose,
  onSuccessAutoClose,
  onAddAccount,
  onSelectAccount,
}) => {
  const assets = useSelector(store => store.asset);
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(PAYPAL_ACCOUNTS_GRID_SCREEN_KEYS, GATEWAY),
    [translationMapper],
  );

  const successText1 = translatedTexts.SUCCESS_TEXT_1;
  const successText2 = translatedTexts.SUCCESS_TEXT_2;

  return (
    <>
      <div className="paypal-accounts-grid-screen-container">
        <div className="paypal-accounts-grid-screen">
          <PayPalAccountsHeader assets={assets} />
          <PayPalAccountsActions
            assets={assets}
            onAddAccount={onAddAccount}
          />
          <PayPalAccountsGrid
            accounts={accounts}
            onSelectAccount={onSelectAccount}
          />
        </div>
      </div>

      <AlertModalPaywaySucces
        open={showSuccessModal}
        type="success"
        onClose={onSuccessClose}
        onAutoClose={onSuccessAutoClose}
        messageArg={[successText1, successText2]}
        gateway={GATEWAY}
      />
    </>
  );
};

export default PayPalAccountsGridScreen;
